module.exports = __webpack_public_path__ + "static/media/SavedSearch.d9538cce.svg";